
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import { knDataExec } from './serverApi/project';

export const GET_KATUZE_ACTION_TYPE = createActionTypes('katuze/GET');

export default function getActions(dispatch) {
    return {
        getKatuze: (token, projectId) => dispatch({
            type: GET_KATUZE_ACTION_TYPE.DEFAULT, token, projectId,
            operation: GET_KATUZE_ACTION_TYPE.DEFAULT
        })
    };
}

function* workGetKatuze(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: GET_KATUZE_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_KATUZE_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, GET_KATUZE_ACTION_TYPE);
    }
}

export function* watchGetKatuze(options) {
    yield takeEvery(
        GET_KATUZE_ACTION_TYPE.DEFAULT, workGetKatuze, options,
        'Načtení seznamu katastrálních území'
    );
}
